<template lang="html">
  <footer id="footer">
  	<div class="container oversized-container">
			<div class="row">
				<div class="col-lg-3 col-logo">
					<router-link to="/">
						<img src="public/images/logo.svg">
					</router-link>
				</div>

				<div class="col-lg-8 col-content">
					<div class="row">
						<div class="col-lg-4 col-footer">
							<h6 class="title">Términos y condiciones generales</h6>

              <p>
								<router-link to="/eum-legal">EUM legal</router-link>
							</p>
              <p>
								<router-link to="/cromatografia-para-cannabinoide">Cromatografia para cannabinoides</router-link>
							</p>
							<p>
								<router-link to="/politica-de-devolucion">Política de devolución</router-link>
							</p>
							<p>
								<router-link to="/terminos-y-condiciones">Términos y condiciones</router-link>
							</p>
							<p>
								<router-link to="/aviso-de-privacidad">Aviso de privacidad</router-link>
							</p>
							<p>
								<a target="_blank" :href="link_cofepris">Aviso de funcionaminto Cofepris</a>
							</p>
							<p>
								<router-link to="/blog">Blog</router-link>
							</p>
						</div>

						<div class="col-sm-6 col-lg col-footer" v-html="body">
							<!-- <h6 class="title">Oficinas USA</h6>
							<p>
                			<span class="f-w-600">EXTRACTOSEUM™️ LLC</span><br />
								2300 W Sahara Ave, SUITE #800,<br />
								Las Vegas, NV, 89102<br />
								Estados Unidos
							</p> -->
						</div>

            			<div class="col-sm-6 col-lg col-footer" v-html="bodytwo">
							<!-- <h6 class="title">Oficinas México</h6>
							<p>
                				<span class="f-w-600">EXTRACTOSEUM™️ S.A.S. De C.V.</span><br />
								Blvr. Periferico Manuel Avila #39,<br />
								Ciudad Satélite,<br />
								Naucalpan de Juárez, 53100
							</p> -->
						</div>

						<div class="col-lg-1 col-footer col-network">
							<div class="box-networks">
								<a class="t-150 btn-network" target="_blank" :href="instagram"><i class="fab fa-instagram"></i></a><br />
								<a class="t-150 btn-network" target="_blank" :href="twitter"><i class="fab fa-twitter"></i></a><br />
								<a class="t-150 btn-network" target="_blank" :href="youtube"><i class="fab fa-youtube"></i></a><br />
								<a class="t-150 btn-network" target="_blank" :href="facebook"><i class="fab fa-facebook-square"></i></a>
							</div>
						</div>
					</div>
				</div>
			</div>
  	</div>
  </footer>
</template>

<script>
export default {
  data(){
    return{
      body: null,
      bodytwo: null,
	  link_cofepris:null,
	  instagram:null,
	  twitter:null,
	  youtube:null,
	  facebook:null,
	  
    }
  },
  methods: {
    getRow: function(){
      axios.get(tools.url('/api/footer')).then((response)=>{
          this.body = response.data.body;
		  this.bodytwo = response.data.bodytwo;
			this.link_cofepris = response.data.link_cofepris;
      });
    },
	getRedes: function(){
      axios.get(tools.url('/api/redes')).then((response)=>{
		this.instagram = response.data.instagram;
		this.twitter = response.data.twitter;
		this.youtube = response.data.youtube;
		this.facebook = response.data.facebook;
       
      });
    }
  },

  mounted(){
   
    this.getRow();
	this.getRedes();
  }
}
</script>
